// extracted by mini-css-extract-plugin
export default {"productGallery":"EJ-z","inQuickShop":"FJ-z"};